import { Component, OnInit, ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { vendor } from '../models/vendorManagement';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-vendormasters',
  templateUrl: './vendormasters.component.html',
  styleUrls: ['./vendormasters.component.css']
})
export class VendormastersComponent implements OnInit {
  vendorAddObj: vendor
  vendorUpdateObj: vendor
  searchValue:any;
  filterValueSelected:any;
  showCustomisedSearch:boolean=false
  showFilter: boolean = false
  userSessionData: any;
  userDetails: any;
  read: any;
  write: any;
  delete: any;
  export:any
  dataSource: any;
  tableData: [] = [];
  show: boolean = false
  userAccountsList: any
  displayedColumns: string[] =  ['accountEmailId', 'vendorName', 'vendorDescription', 'category', 'subCategory', 'vendorCompany', 'vendorGSTIN', 'vendorLocation', 'vendorAddress','status', 'dateOfCreation','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("vendor") form: any;
  @ViewChild("vendorUpdate", { static: true }) formUpdate: any;
  subCategoriesList: any;
  showTextField: boolean=false;
  categoriesList: any;
  showSubTextField: boolean=false;
  constructor(private cs: CucurachaAdminService, private excelService: ExcelService, private toastr: ToastrManager) {
    this.vendorAddObj = new vendor()
    this.vendorUpdateObj = new vendor()

  }
  filter() {
    this.getAllVendorMatersManagement()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllVendorMatersManagement();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForVendors(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllVendorMatersManagement()
    }
  }
  addVendor() {

    if (this.show == false) {
      this.show = true
    }
    else {

      this.show = false
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable() {
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'VendorManagement');
    this.cs.exportLogAdd(this.userDetails.emailId, 'VendorManagement').subscribe((data) => {
    })
  }
  saveVendor() {
    this.cs.saveVendor(this.vendorAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllVendorMatersManagement();
        this.toastr.successToastr(data.message);
        this.form.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }

    });

  }
  updateVendor() {
    this.cs.updateVendor(this.vendorUpdateObj).subscribe((data) => {
      if (data.result) {
        this.getAllVendorMatersManagement();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }

    });

  }
  getAllVendorMatersManagement() {
    this.cs.getAllVendorMatersManagement().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  getAllUserAccountsByStatus() {
    this.cs.getAllAccountsByStatus ().subscribe((data) => {
      this.userAccountsList = data
    })
  }
  getAllCategories(){
    this.cs.getAllCategory().subscribe((data) => {
     this.categoriesList=data

    });
  }
  
  getSubCategoryByCategoryId(id:any){
    if(this.vendorAddObj.category!="Others"){
    this.cs.getSubCategoryByCategoryId(id).subscribe((data) => {
  this.subCategoriesList=data     
    });
    
  }
  if(this.vendorAddObj.category=="Others"){
      this.showTextField=true
    
  }

  }
  checking(id:any){
    if(this.vendorAddObj.subCategory=="Others"){
      this.showSubTextField=true

    }
  }
  getByVendorId(id){
    this.cs.getByVendorId(id).subscribe((data) => {
      this.vendorUpdateObj._id = data[0]._id;
      this.vendorUpdateObj.accountId = data[0].accountId;

      this.vendorUpdateObj.vendorName = data[0].vendorName;
      this.vendorUpdateObj.vendorDescription = data[0].vendorDescription
      this.vendorUpdateObj.category = data[0].category
      this.vendorUpdateObj.subCategory = data[0].subCategory
      this.vendorUpdateObj.vendorCompany = data[0].vendorCompany
      this.vendorUpdateObj.vendorGSTIN = data[0].vendorGSTIN
      this.vendorUpdateObj.vendorLocation = data[0].vendorLocation
      this.vendorUpdateObj.vendorAddress = data[0].vendorAddress

    })
  }

  onChange(status, id) {
    console.log(status.checked)
    this.cs.getByVendorId(id).subscribe((data) => {
      this.vendorAddObj._id = data[0]._id;
      this.vendorAddObj.status = status.checked;

      this.cs.updateVendorStatus(this.vendorAddObj).subscribe((data) => {
        if(data.result ){
          this.toastr.infoToastr(data.message);

          this.getAllVendorMatersManagement()
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.getAllVendorMatersManagement()
    
         }
          else{
            this.toastr.errorToastr(data.message);
            this.getAllVendorMatersManagement()

    
          }
      })
    })
  }
  ngOnInit(): void {
    this.getAllVendorMatersManagement();
    this.getAllUserAccountsByStatus();

    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].delete)
      this.export = (this.userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].export)

    })
    this.getAllCategories();
    this.subCategoriesList();
  }


}
